import React, { useRef, useState } from 'react';
import { FloatingCartButton } from './FloatingCartButton';
import { CartDrawer } from './CartDrawer';
import { useCart } from '../../../utils/hook/useCart';
import { useRouteMenuId } from '../../../utils/hook/useRouteMenuId';
import { useOrderingEnabled } from '../../../utils/hook/useOrderingEnabled';
import { useActiveOrder } from '../../../utils/hook/useActiveOrder';

const IGNORE_CLOSE_MS = 400;

export const CartLayer = () => {
    const { count, menuId } = useCart();
    const routeMenuId = useRouteMenuId();
    const orderingEnabled = useOrderingEnabled();
    // Owned here rather than in the drawer: the floating button has to
    // know about a running order too, and two copies of that state would
    // drift the moment one of them updated.
    const activeOrder = useActiveOrder(menuId);
    const [open, setOpen] = useState(false);
    const ignoreCloseUntil = useRef(0);

    const openCart = () => {
        ignoreCloseUntil.current = Date.now() + IGNORE_CLOSE_MS;
        setOpen(true);
    };

    const closeCart = () => {
        if (Date.now() < ignoreCloseUntil.current) return;
        setOpen(false);
    };

    // Ordering belongs to the menu on screen, and only to restaurants the
    // feature is switched on for. Off a menu route — or before the page has
    // bound the cart to it — there is nothing to check out.
    if (!orderingEnabled || routeMenuId === null || menuId !== routeMenuId) return null;

    return (
        <>
            <FloatingCartButton
                count={count}
                hasActiveOrder={activeOrder.active !== null}
                onOpen={openCart}
            />
            <CartDrawer open={open} onClose={closeCart} activeOrder={activeOrder} />
        </>
    );
};
